import SliderType from './SliderType';
export default SliderType;
